<template>
    <div>
        <info-item
                :isEnabled="isEnabled"
                :label="resource('DmChangeInfoModel_Remarks_Label')"
                @set-enabled="$emit('set-enabled', $event)"
        >
            <info-text-area-input
                    :isEnabled="isEnabled"
                    :value="remarks"
                    @input="$emit('input', $event)"
            />
        </info-item>
    </div>
</template>

<script>
    import resourceMixin from '../../../../Util/Mixins/resources';

    import InfoItem from './InfoItem.vue';
    import InfoTextAreaInput from './Components/InfoTextAreaInput.vue';
    
    export default {
        name: "info-remarks",
        mixins: [resourceMixin],
        components: {
            InfoItem,
            InfoTextAreaInput
        },
        data() {
            return {
                remarks: ""
            };
        },
        props: {
            isEnabled: {
                type: Boolean,
                required: true
            }
        }
    }
</script>

<style scoped>

</style>
